import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cradua-list-spinner',
  templateUrl: './list-spinner.component.html',
  styleUrls: ['./list-spinner.component.scss']
})
export class ListSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
